import React, { Component } from 'react';
import { number } from 'prop-types';
import { currencyFormatter } from 'ps-components/Modules/JobRanges/Utils/Utils';
import RangeChart from 'ps-components/RangeChart/RangeChart';
import './SalaryRangeChart.scss';

class SalaryRangeChart extends Component {
  static propTypes = {
    currentMaxValue: number,
    currentMidValue: number,
    currentMinValue: number,
    proposedMaxValue: number,
    proposedMidValue: number,
    proposedMinValue: number,
    roundTo: number
  };

  bottomLabelFormatter = (val, index, context) => {
    if (index === 1) return '';
    return currencyFormatter(val, { ...context });
  };

  renderCurrentRangeChart = (rangeValues, scaleMax, scaleMin) => {
    const { roundTo } = this.props;

    return (
      <div className="salary__range-current">
        <span className="range__label current__range-label">Current</span>
        <RangeChart
          barHeight={15}
          bottomLabelFormatter={this.bottomLabelFormatter}
          colors={['#2D67B9', '#5389D5']}
          data={rangeValues}
          height={20}
          hideTopLabels
          id="salary__range-chart1"
          invertLabels
          labelsVisible
          labelTextAnchor={['start', 'middle', 'end']}
          labelToBarSpacingTop={5}
          payType="annual"
          roundToNearest={1}
          scaleMax={scaleMax}
          scaleMin={scaleMin}
          width={300}
        />
      </div>
    );
  };

  renderNoDataPlaceholder = () => {
    return (
      <div className="pxl-header-xxsmall salary__range-no-data">There is no salary range assigned to this job.</div>
    );
  };

  renderProposedRangeChart = (proposedRangeValues, scaleMax, scaleMin) => {
    const { roundTo } = this.props;

    return (
      <div className="salary__range-proposed">
        <span className="range__label proposed__range-label">Proposed</span>
        <RangeChart
          barHeight={15}
          bottomLabelFormatter={this.bottomLabelFormatter}
          colors={['#22D6DD', '#A7EFF1']}
          data={proposedRangeValues}
          height={20}
          hideTopLabels
          id="salary__range-chart2"
          labelsVisible
          labelTextAnchor={['start', 'middle', 'end']}
          labelToBarSpacingBottom={15}
          payType="annual"
          roundToNearest={roundTo}
          scaleMax={scaleMax}
          scaleMin={scaleMin}
          width={300}
        />
      </div>
    );
  };

  render() {
    const {
      currentMaxValue,
      currentMidValue,
      currentMinValue,
      proposedMinValue,
      proposedMidValue,
      proposedMaxValue,
      roundTo
    } = this.props;

    const proposedRangeValues = [proposedMinValue, proposedMidValue, proposedMaxValue];
    const rangeValues = [currentMinValue, currentMidValue, currentMaxValue];
    const scaleMax = Math.max(...rangeValues, ...proposedRangeValues);
    const scaleMin = Math.min(...rangeValues, ...proposedRangeValues);
    const showCurrentRangeChart = !rangeValues.includes(0);

    const hasDifferentProposedValues =
      currentMaxValue !== proposedMaxValue ||
      currentMidValue !== proposedMidValue ||
      currentMinValue !== proposedMinValue;
    const proposedValuesNotEqual =
      proposedMinValue !== proposedMidValue ||
      proposedMinValue !== proposedMaxValue ||
      proposedMidValue !== proposedMaxValue;
    const hasProperMinMidMaxOrder = proposedMinValue < proposedMidValue && proposedMidValue < proposedMaxValue;
    const showProposedRangeChart =
      hasDifferentProposedValues &&
      !proposedRangeValues.includes(0) &&
      proposedValuesNotEqual &&
      hasProperMinMidMaxOrder;

    return (
      <div className="salary__range-chart">
        <div className="salary__range-title">Salary Range</div>
        {!showCurrentRangeChart && !showProposedRangeChart && this.renderNoDataPlaceholder()}
        {showCurrentRangeChart && this.renderCurrentRangeChart(rangeValues, scaleMax, scaleMin)}
        {showProposedRangeChart && this.renderProposedRangeChart(proposedRangeValues, scaleMax, scaleMin)}
      </div>
    );
  }
}

export default SalaryRangeChart;
